
import { computed, defineComponent, watch } from 'vue';
import { useRoute } from 'vue-router';
import KTTopbar from '@/layout/header/Topbar.vue';
import PageToolbarHeader from '@/layout/header/PageToolbarHeader.vue';
import { usePageToolbar } from '@/core/hooks/usePageToolbar';
import {
  headerWidthFluid,
  headerLeft,
  asideDisplay,
} from '@/core/helpers/config';

export default defineComponent({
  name: 'KTHeader',
  props: {
    title: String,
    /** Hide back on dashboard (and similar). */
    hideBack: {
      type: Boolean,
      default: false,
    },
    /** Force-hide page toolbar (dashboard / fullscreen handled by parent). */
    hidePageToolbar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    KTTopbar,
    PageToolbarHeader,
  },
  setup(props) {
    const route = useRoute();
    const {
      pageToolbar,
      hasHeaderBanner,
      displayTitle,
      syncBodyClasses,
    } = usePageToolbar();

    const showPageToolbar = computed(() => {
      if (props.hidePageToolbar) {
        return false;
      }
      // Dashboard keeps a clean chrome; all other app pages use the new header.
      if (route.name === 'dashboard') {
        return false;
      }
      return true;
    });

    const bannerStyle = computed(() => {
      const url = pageToolbar.backgroundUrl?.trim();
      if (!url) {
        return undefined;
      }
      return {
        '--header-banner-bg': `url(${JSON.stringify(url)})`,
      } as Record<string, string>;
    });

    watch(
      [showPageToolbar, hasHeaderBanner, displayTitle],
      () => {
        syncBodyClasses(showPageToolbar.value);
      },
      { immediate: true },
    );

    return {
      headerWidthFluid,
      headerLeft,
      asideDisplay,
      showPageToolbar,
      hasHeaderBanner,
      bannerStyle,
    };
  },
});
